import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    Button, CircularProgress, IconButton, Tooltip, Drawer, Box, TextField, FormControl,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    InputLabel,
    Checkbox,
    Slider,
    Typography,
    Select,
    MenuItem,
    Stack,
    OutlinedInput,
    Autocomplete,
    Chip,
} from '@mui/material'

import AddIcon from "@mui/icons-material/Add";
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import DeleteIcon from "@mui/icons-material/Delete";
import usePrescriptionStore from '../DataRepository/Prescription'
import { profileModel } from '../Axios/AxiosConfig'

const indianStates = [
    "South Indian", "North Indian",
    "Andhra",
    "Assamese",
    "Bengali",
    "Bihari",
    "Goan",
    "Gujarati",
    "Haryana",
    "Hyderabadi",
    "Jharkhand",
    "Karnataka",
    "Kashmiri",
    "Kerala",
    "Lucknow",
    "Maharashtrian",
    "Mughlai",
    "Oriya",
    "Punjabi",
    "Rajasthani",
    "Tamilnadu",
    "Uttar Pradesh",
    "Uttarakhand"
]


function RecipeSuggestions() {

    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");

    const [Prakriti_details, setPrakritiDetails] = useState(null)

    const [AllRecipes, setAllRecipes] = useState([]);

    const [selectedIntensity, setSelectedIntensity] = useState('');

    const [foodPreference, setFoodPreference] = useState('');

    const [selectedTimning, setSelectedTiming] = useState(null);

    const [vikritidata, setvikritidata] = useState(null);

    const [isOpen, setIsOpen] = useState(false);

    const [Dosham, setDosham] = useState({
        Increased: {
            doshas: [],
            percentage: {},
            intensity: {}
        },
        Decreased: {
            doshas: [],
            percentage: {},
            intensity: {}
        }
    });

    const [symptomInput, setSymptomInput] = useState('');

    const [diseaseInput, setDiseaseInput] = useState('');

    const Intensityoptions = ['Slightly', 'Moderately', 'Significantly'];

    const foodOptions = ['Vegetarian', 'Non-Vegetarian', 'Vegan', 'Eggitarian', 'Sattvic'];

    const [currentDietEntries, setCurrentDietEntries] = useState({
        breakfast: [],
        lunch: [],
        snacks: [],
        dinner: []
    });

    const [currentDietInput, setCurrentDietInput] = useState({
        breakfast: '',
        lunch: '',
        snacks: '',
        dinner: ''
    });

    const [selectedStates, setSelectedStates] = useState([]);

    const handleChange = (event) => {
        const { value } = event.target;
        setSelectedStates(Array.isArray(value) ? value : []);
    };

    const handleDelete = (stateToDelete) => {
        setSelectedStates((prevSelected) =>
            prevSelected.filter((state) => state !== stateToDelete)
        );
    };

    const toggleDrawer = (open, timing) => () => {
        setIsOpen(open);
        setSelectedTiming(timing);
        setSearchTerm("");
    };

    const {
        selectedPatientdetails,
        selectedRecipes,
        handleSelectRecipe,
        symptoms,
        setSymptoms,
        diseases,
        setDiseases,
        Medicaldetails,
        setMedicaldetails,
        setOpenRecipeAI,
        setRecipeLoading,
        selectedAppointemntdetails,
        setRecipeAIRecommendation,
        recipeAIRecommendation,
        recipeLoading,
        openRecipeAI
    } = usePrescriptionStore();

    function cleanJsonString(rawString) {
        return rawString
            .replace(/```json/, '')
            .replace(/```$/, '')
            .trim();
    }

    const formatDoshaDetails = (type) => {
        return Dosham?.[type]?.doshas?.map((dosha) => {
            const percent = Dosham[type].percentage?.[dosha] || '';
            const intensity = Dosham[type].intensity?.[dosha] || '';
            const details = [];

            if (percent) details.push(`${percent}%`);
            if (intensity) details.push(intensity);

            return `${dosha.charAt(0).toUpperCase() + dosha.slice(1)}${details.length ? ` (${details.join(', ')})` : ''}`;
        }).join(', ');
    };


    const handleMedicaldetails = (name, value) => {
        setMedicaldetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const severityMap = {
        0: "Good",
        1: "Mild",
        2: "Moderate",
        3: "High",
        4: "Severe",
        5: "Extreme",
    };

    const handleRecipeAIRecommedation = async () => {
        try {
            setOpenRecipeAI(true);
            setRecipeLoading(true);

            const timings = ["breakfast", "lunch", "snack", "dinner"];

            const decreasedDetails = formatDoshaDetails('Decreased');
            const increasedDetails = formatDoshaDetails('Increased');

            const vikriti = [
                decreasedDetails ? `${decreasedDetails} Decreased` : '',
                increasedDetails ? `${increasedDetails} Increased` : ''
            ].filter(Boolean).join(', ');

            const symptomsString = symptoms?.length > 0
                ? symptoms
                    .map(
                        (s) =>
                            `${s.symptoms} (Severity: ${severityMap[s.severity] || "N/A"}, Duration: ${s.duration || "N/A"}, Frequency: ${s.frequency || "N/A"})`
                    )
                    .join(", ")
                : "";

            const diseaseListString = [
                Medicaldetails?.ayurvedadiagnosis && `Ayurveda: ${Medicaldetails.ayurvedadiagnosis}`,
                Medicaldetails?.moderndiagnosis && `Modern: ${Medicaldetails.moderndiagnosis}`
            ].filter(Boolean).join(' | ');

            for (const time of timings) {
                try {

                    const res = await profileModel.post('/getRecipeRecommendationFromAIWithParam', {
                        UID: selectedPatientdetails.UID,
                        time,
                        food_preference: foodPreference,
                        preferred_cuisines: selectedStates.length > 0 ? selectedStates.join(',') : "",
                        change_intensity: selectedIntensity,
                        vikriti,

                        appointmentId: selectedAppointemntdetails?.appointmentId || "",

                        current_diet_breakfast: currentDietEntries?.breakfast?.length > 0
                            ? currentDietEntries.breakfast.join(', ')
                            : '',

                        current_diet_lunch: currentDietEntries?.lunch?.length > 0
                            ? currentDietEntries.lunch.join(', ')
                            : '',

                        current_diet_snacks: currentDietEntries?.snacks?.length > 0
                            ? currentDietEntries.snacks.join(', ')
                            : '',

                        current_diet_dinner: currentDietEntries?.dinner?.length > 0
                            ? currentDietEntries.dinner.join(', ')
                            : '',
                        symptomsString,
                        diseaseListString
                    });

                    if (res.status === 200) {
                        const { analysis } = res.data;
                        const raw = analysis;
                        const cleanedJson = raw ? cleanJsonString(raw) : null;
                        const parsedData = cleanedJson ? JSON.parse(cleanedJson) : null;
                        const { foods_recommended } = parsedData || {};

                        const taggedRecommendations = (foods_recommended || []).map(recipe => ({
                            ...recipe,
                            time,
                        }));

                        setRecipeAIRecommendation(taggedRecommendations);
                    }
                } catch (singleErr) {
                    console.log(`Failed to fetch for time: ${time}`, singleErr);
                }
            }

            setRecipeLoading(false);

        } catch (err) {
            console.log(err);
            setRecipeLoading(false);
        }
    };

    const getAllRecipes = async () => {
        try {
            let res = await profileModel.get("/AllRecipes");
            if (res?.status === 200) {
                setAllRecipes(res?.data);
            }
        } catch (err) {
            console.log(err?.response?.data);
        }
    };

    const getVikritiData = async () => {
        try {
            let res = await profileModel.get("fetchVikritidata", {
                id: selectedPatientdetails?.UID,
            });
            if (res.status == 200) {
                setvikritidata(res.data);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleSymptomChange = (index, newSymptom) => {
        const updatedData = [...symptoms];
        updatedData[index].symptoms = newSymptom;
        setSymptoms(updatedData);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleAddRow = () => {
        setSymptoms([...symptoms, { symptoms: "", severity: 0 }]);
    };

    const handleDurationChange = (index, value) => {
        setSymptoms((prev) => {
            const updated = [...prev];
            updated[index].duration = value;
            return updated;
        });
    };

    const handleFrequencyChange = (index, value) => {
        setSymptoms((prev) => {
            const updated = [...prev];
            updated[index].frequency = value;
            return updated;
        });
    };

    const handleSeverityChange = (index, newValue) => {
        const updatedData = symptoms.map((item, i) =>
            i === index ? { ...item, severity: newValue } : item
        );
        setSymptoms(updatedData);
    };

    const handleAddDiseases = () => {
        const newDiseases = diseaseInput
            .split(',')
            .map(s => s.trim())
            .filter(s => s.length > 0 && !diseases.includes(s));

        if (newDiseases.length > 0) {
            setDiseases([...diseases, ...newDiseases]);
            setDiseaseInput('');
        }
    };

    const handleSymptomDelete = (symptomToDelete) => () => {
        setSymptoms(symptoms.filter(s => s !== symptomToDelete));
    };

    const handleDiseasesDelete = (diseaseToDelete) => () => {
        setDiseases(diseases.filter(d => d !== diseaseToDelete));
    };

    const handleDeleteRow = (index) => {
        const updatedData = symptoms.filter((_, i) => i !== index);
        setSymptoms(updatedData);
    };

    const handleDiseaseFieldChange = (index, field, value) => {
        setDiseases(prev =>
            prev.map((d, i) =>
                i === index ? { ...d, [field]: value } : d
            )
        );
    };

    const getPrakritiData = async () => {
        try {
            let res = await profileModel.get(`/GetPrakritidata/${selectedPatientdetails?.UID}`);
            if (res.status === 200) {
                setPrakritiDetails(res.data)
            }
        } catch (err) {
            console.log(err?.response?.data);
        }
    };

    useEffect(() => {
        getAllRecipes();
        getPrakritiData();
        getVikritiData();
    }, [])


    const handleKeyPress = (event) => {
        const charCode = event?.charCode;
        if (event?.keyCode !== 8 && (charCode < 48 || charCode > 57)) {
            event?.preventDefault();
        }
    };

    function findVPKResult(arrayList) {
        try {
            const datamap = {
                V: arrayList[0],
                P: arrayList[1],
                K: arrayList[2],
            };

            const datamap1 = {
                [arrayList[0]]: "V",
                [arrayList[1]]: "P",
                [arrayList[2]]: "K",
            };

            const v = Math.max(...arrayList);
            const k = Math.min(...arrayList);

            const p = arrayList.reduce((sum, current) => sum + current, 0) - (v + k);

            if (v - p > 20) {
                return datamap1[v];
            } else if (v - p <= 20 && p - k > 5) {
                if (v === p) {
                    const dominant = Object.entries(datamap)
                        .filter(([key, value]) => value === v)
                        .map(([key]) => key)
                        .join("");
                    return dominant;
                } else {
                    return datamap1[v] + datamap1[p];
                }
            } else {
                return datamap1[v] + datamap1[p] + datamap1[k];
            }
        } catch (error) {
            console.error("Error in findVPKResult:", error);
            return null;
        }
    }

    const HandleDosham = (type, dosha, isChecked) => {
        setDosham(prev => {
            const updatedDoshas = isChecked
                ? [...prev[type].doshas, dosha]
                : prev[type].doshas.filter(d => d !== dosha);

            return {
                ...prev,
                [type]: {
                    ...prev[type],
                    doshas: updatedDoshas
                }
            };
        });
    };

    const updateDoshaPercentage = (type, dosha, value) => {
        setDosham(prev => ({
            ...prev,
            [type]: {
                ...prev[type],
                percentage: {
                    ...prev[type].percentage,
                    [dosha]: value
                }
            }
        }));
    };

    const updateDoshaIntensity = (type, dosha, value) => {
        setDosham(prev => ({
            ...prev,
            [type]: {
                ...prev[type],
                intensity: {
                    ...prev[type].intensity,
                    [dosha]: value
                }
            }
        }));
    };

    const handleAddMealItem = (mealType) => {
        const newItems = currentDietInput[mealType]
            .split(',')
            .map(i => i.trim())
            .filter(i => i.length > 0 && !currentDietEntries[mealType].includes(i));

        if (newItems.length > 0) {
            setCurrentDietEntries(prev => ({
                ...prev,
                [mealType]: [...prev[mealType], ...newItems]
            }));
            setCurrentDietInput(prev => ({ ...prev, [mealType]: '' }));
        }
    };

    const handleDeleteMealItem = (mealType, item) => () => {
        setCurrentDietEntries(prev => ({
            ...prev,
            [mealType]: prev[mealType].filter(i => i !== item)
        }));
    };

    const renderMealSection = (label, key) => (
        <div className='mt-5 flex flex-row items-center w-full' key={key}>
            <div className="min-w-[100px]">
                <p className="text-[#3B362A] font-medium">{label}:</p>
            </div>
            <div className='mt-2 mb-2 w-full flex-1'>
                <Autocomplete
                    multiple
                    freeSolo
                    options={[]} // No predefined options
                    value={currentDietEntries[key]}
                    onChange={(event, newValue) => {
                        const unique = [...new Set(newValue.map(i => i.trim()).filter(i => i))];
                        setCurrentDietEntries(prev => ({ ...prev, [key]: unique }));
                    }}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                label={option}
                                {...getTagProps({ index })}
                                sx={{
                                    backgroundColor: '#EFEFE7',
                                    color: '#3B362A',
                                    borderRadius: '5px',
                                    fontWeight: 500,
                                    fontFamily: "'Poppins', sans-serif"
                                }}
                            />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            // label={`Enter ${label.toLowerCase()} items`}
                            placeholder="Add items"
                            sx={{
                                backgroundColor: '#FDFDFD',
                                input: {
                                    color: '#3B362A',
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500
                                },
                                label: {
                                    color: '#3B362A'
                                },
                                '.MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ccc'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#aaa'
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#75623F'
                                    }
                                }
                            }}
                        />
                    )}
                    fullWidth
                />
            </div>
        </div>
    );

    const handleDiseaseChange = (index, value) => {
        setDiseases((prev) => {
            const updated = [...prev];
            updated[index].disease = value;
            return updated;
        });
    };

    const handleDiseaseDurationChange = (index, value) => {
        setDiseases((prev) => {
            const updated = [...prev];
            updated[index].duration = value;
            return updated;
        });
    };

    const handleDiseaseSeverityChange = (index, value) => {
        setDiseases((prev) => {
            const updated = [...prev];
            updated[index].severity = value;
            return updated;
        });
    };

    const handleAddDisease = () => {
        setDiseases((prev) => [...prev, { disease: "", duration: "", severity: 0 }]);
    };

    const handleDeleteDisease = (index) => {
        setDiseases((prev) => prev.filter((_, i) => i !== index));
    };

    const ratings = ["None", "Mild", "Moderate", "High", "Severe", "Extreme"];

    console.log(selectedTimning);

    return <div className='All-products-section-main'>

        <nav
            className='fixed top-0 w-full z-50 flex flex-row p-2 items-center justify-between'
            style={{ backgroundColor: "#f4ecd6" }}
        >
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p
                    className='mb-0'
                    style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                    }}
                >
                    Recipes
                </p>
            </div>
        </nav>


        <div className='flex flex-col gap-4 p-4 pt-20'>
            <div className='flex flex-col gap-4 bg-[#FAF6EC] p-4 rounded-lg'>

                <div className='flex flex-col gap-4'>
                    <div>

                        <p className='rec-rem-T'>Cuisine Preferences</p>

                        <div className='mt-2'>
                            <Autocomplete
                                multiple
                                options={indianStates}
                                value={selectedStates}
                                onChange={(event, newValue) => {
                                    setSelectedStates(newValue);
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            key={option}
                                            label={option}
                                            sx={{
                                                backgroundColor: '#EFEFE7',
                                                color: '#3B362A',
                                                borderRadius: '5px',
                                                fontWeight: 500,
                                                fontFamily: "'Poppins', sans-serif"
                                            }}
                                            {...getTagProps({ index })}
                                        />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        sx={{
                                            backgroundColor: '#FDFDFD',
                                            input: {
                                                color: '#3B362A',
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500
                                            },
                                            label: {
                                                color: '#3B362A'
                                            },
                                            '.MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#ccc'
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#aaa'
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#75623F'
                                                }
                                            }
                                        }}

                                    />
                                )}
                            />
                        </div>

                    </div>

                    <div className='flex flex-row items-center justify-between'>

                        <div>
                            <div>
                                <p className='rec-rem-T' >Food Preferences:</p>
                            </div>

                            <div className='mt-2'>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {foodOptions.map((option) => (
                                        <button
                                            key={option}
                                            onClick={() => setFoodPreference(option)}
                                            style={{
                                                padding: '5px 1rem',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                backgroundColor: foodPreference === option ? '#8CEB8C' : '#f0f0f0',
                                                color: '#3B362A',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {option}
                                        </button>
                                    ))}
                                </div>
                            </div>

                        </div>

                        <div>
                            <p className='rec-rem-T' >Dietary Change Intensity:</p>
                            <div className='mt-2'>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    {Intensityoptions.map((option) => (
                                        <button
                                            key={option}
                                            onClick={() => setSelectedIntensity(option)}
                                            style={{
                                                padding: '5px 1rem',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                backgroundColor: selectedIntensity === option ? '#8CEB8C' : '#f0f0f0',
                                                color: '#3B362A',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {option}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className='flex flex-col justify-between'>
                        <div>
                            {symptoms && symptoms.length > 0 &&
                                <div>
                                    <p className="Prescription-sh-h">Chief Complaints</p>
                                    <div style={{ padding: '1rem' }}>
                                        <TableContainer>
                                            <Table aria-label="symptoms table">
                                                <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                    <TableRow>
                                                        <TableCell sx={{ width: '30%' }} align="center"
                                                            style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "#3B362A",
                                                                fontSize: "16px",
                                                                padding: "10px"
                                                            }}>Symptom</TableCell>
                                                        <TableCell sx={{ width: '40%' }} align="center" style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "#3B362A",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Severity</TableCell>
                                                        <TableCell sx={{ width: '30%' }} align="center"
                                                            style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "#3B362A",
                                                                fontSize: "16px",
                                                                padding: "10px"
                                                            }}>Duration</TableCell>
                                                        <TableCell sx={{ width: '30%' }} align="center"
                                                            style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "#3B362A",
                                                                fontSize: "16px",
                                                                padding: "10px"
                                                            }}>Frequency</TableCell>
                                                        <TableCell sx={{ width: '30%' }} align="center"
                                                            style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "#3B362A",
                                                                fontSize: "16px",
                                                                padding: "10px"
                                                            }}>Goal</TableCell>
                                                        <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                    {symptoms?.map((e, i) => (
                                                        <TableRow key={i}>
                                                            <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                                <p style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                }}>{e?.symptoms}</p>
                                                            </TableCell>
                                                            <TableCell sx={{ width: '40%' }}>
                                                                <div className="flex items-center justify-center space-x-6">
                                                                    {ratings?.map((label, index) => (
                                                                        <div
                                                                            key={index}
                                                                            className="flex flex-col items-center cursor-pointer"
                                                                        >
                                                                            <div
                                                                                className={`w-6 h-6 rounded-full transition-all duration-300 ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                    }`}
                                                                            ></div>
                                                                            <span className="mt-2 text-sm text-gray-700" style={{
                                                                                fontFamily: "'Poppins', sans-serif",
                                                                                fontWeight: 400,
                                                                            }}>{label}</span>
                                                                        </div>
                                                                    ))}

                                                                    {/* <p style={{
                                                                                              fontFamily: "'Poppins', sans-serif",
                                                                                              fontWeight: 500,
                                                                                              color: "#3B362A",
                                                                                              fontSize: "16px",
                                                                                          }}>{ratings[e?.severity]}</p> */}

                                                                </div>
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: '30%' }}>
                                                                <p style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                }}>{e?.duration}</p>
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: '30%' }}>
                                                                <p style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                }}>{e?.frequeny}</p>
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: '30%' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={e?.goal}
                                                                    readOnly
                                                                    onClick={(e) => e.preventDefault()}
                                                                    style={{
                                                                        width: '16px',
                                                                        height: '16px',
                                                                        accentColor: '#DA6E0B',
                                                                        cursor: 'default',
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            }

                        </div>

                        <div>
                            <div className="flex flex-row justify-between items-center">
                                <p className="Prescription-sh-h">Diagnosis</p>
                            </div>

                            <div className="mt-2 flex gap-4 flex-wrap">
                                <div style={{ maxWidth: "500px", width: "100%" }}>
                                    <p className="text-sm text-gray-600 mb-1 font-semibold">Ayurveda Diagnosis</p>
                                    <div className="p-3 border rounded bg-gray-50 text-gray-800">
                                        {Medicaldetails?.ayurvedadiagnosis || '—'}
                                    </div>
                                </div>

                                <div style={{ maxWidth: "500px", width: "100%" }}>
                                    <p className="text-sm text-gray-600 mb-1 font-semibold">Modern Diagnosis</p>
                                    <div className="p-3 border rounded bg-gray-50 text-gray-800">
                                        {Medicaldetails?.moderndiagnosis || '—'}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div>
                    <p className='rec-rem-T'>Current Diet</p>

                    <div className='mt-2'>
                        {renderMealSection('Breakfast', 'breakfast')}

                        {renderMealSection('Lunch', 'lunch')}
                        {renderMealSection('Snacks', 'snacks')}
                        {renderMealSection('Dinner', 'dinner')}
                    </div>

                </div>

                <div className='flex align-items-center justify-end'>
                    <Button
                        onClick={handleRecipeAIRecommedation}
                        sx={{
                            mt: 2,
                            backgroundColor: '#DA6E0B',
                            color: 'white',
                            borderRadius: '5px',
                            padding: "10px 2rem",
                            textTransform: 'none',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            '&:hover': {
                                backgroundColor: '#B55A09',
                                color: 'white'
                            }
                        }}>
                        {recipeLoading ? <CircularProgress size={30} sx={{ color: "#fdfdfd" }} /> : <div>
                            <p style={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                            }}>Generate Recipes</p>
                        </div>
                        }
                    </Button>
                </div>

            </div>

            <div>
                {recipeAIRecommendation.length > 0 &&
                    <div className='flex flex-col gap-4 p-4 rounded-lg'>

                        <div className="p-5 flex flex-col gap-5" >
                            <div className="flex flex-row justify-between items-center px-2" style={{
                                borderLeft: "5px solid #DA6E0B",
                                borderRadius: "8px"
                            }}>
                                <p style={{
                                    fontSize: "18px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                }}>Breakfast</p>
                                <Button
                                    onClick={toggleDrawer(true, "breakfast")}
                                    sx={{
                                        mt: 2,
                                        backgroundColor: '#fdfdfd',
                                        color: '#DA6E0B',
                                        borderRadius: '5px',
                                        padding: "5px 1rem",
                                        textTransform: 'none',
                                        border: "1px solid #DA6E0B",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,

                                    }}>
                                    <p style={{

                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                    }}>Add more</p>
                                </Button>
                            </div>


                            <div className="flex flex-wrap  items-stretch">
                                {Array.from(
                                    new Map(
                                        [...recipeAIRecommendation, ...selectedRecipes]
                                            .filter((recipe) => recipe.time.includes('breakfast'))
                                            .map((recipe) => [recipe.id, recipe])
                                    ).values()
                                )
                                    .map((item) => {
                                        const isSelected = selectedRecipes.some((i) => i.id === item.id);
                                        return (
                                            <Tooltip
                                                key={item.id}
                                                title={
                                                    <span>
                                                        <strong>Reason:</strong> {item?.reason}<br />
                                                        <strong>Dosha to Decrease:</strong> {item?.doshaDecrease}
                                                    </span>
                                                }

                                                arrow
                                                placement="bottom"
                                            >
                                                <div
                                                    className="food-item relative"
                                                    onClick={() => handleSelectRecipe({ ...item, time: 'breakfast' }, !isSelected)}
                                                >
                                                    <div className="food-item-img-container mb-2">
                                                        <img
                                                            src={
                                                                item.imageLink?.includes('https://example.com/')
                                                                    ? "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png"
                                                                    : item.imageLink
                                                            }
                                                            onError={(e) => {
                                                                e.target.onerror = null; // prevent infinite loop
                                                                e.target.src = "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png";
                                                            }}
                                                            alt="Recipe"
                                                            className='food-image'
                                                        />

                                                        <input
                                                            type="checkbox"
                                                            className="overlay-checkbox"
                                                            checked={isSelected}
                                                            readOnly
                                                            style={{
                                                                width: "auto",
                                                                height: "auto",
                                                                top: "5px",
                                                                right: "8px",
                                                            }}
                                                        />
                                                    </div>

                                                    <p
                                                        className="mt-5 w-full"
                                                        style={{ wordWrap: "break-word", width: "10rem" }}
                                                    >
                                                        {item?.recipe || item?.name}
                                                    </p>
                                                </div>
                                            </Tooltip>
                                        );
                                    })}
                            </div>
                        </div>

                        <div className="p-5 flex flex-col gap-5" >

                            <div className="flex flex-row justify-between items-center px-2" style={{
                                borderLeft: "5px solid #DA6E0B",
                                borderRadius: "8px"
                            }} >
                                <p style={{
                                    fontSize: "18px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                }}>Mid-day Snacks</p>
                                <Button
                                    onClick={toggleDrawer(true, "mid-day-snack")}
                                    sx={{
                                        mt: 2,
                                        backgroundColor: '#fdfdfd',
                                        color: '#DA6E0B',
                                        borderRadius: '5px',
                                        padding: "5px 1rem",
                                        textTransform: 'none',
                                        border: "1px solid #DA6E0B",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,

                                    }}>
                                    <p style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                    }}>Add more</p>
                                </Button>
                            </div>

                            <div className="flex flex-wrap items-stretch">
                                {Array.from(
                                    new Map(
                                        [...recipeAIRecommendation.filter((recipe) => recipe.time.includes('snack')), ...selectedRecipes.filter((recipe) => recipe.time === ('mid-day-snack'))]
                                            .map((recipe) => [recipe.id, recipe])
                                    ).values()
                                ).map((item) => {
                                    const isSelected = selectedRecipes.some((i) => i.id === item.id && i.time === 'mid-day-snack');
                                    return (
                                        <Tooltip
                                            key={item.id}
                                            title={
                                                <span>
                                                    <strong>Reason:</strong> {item?.reason}<br />
                                                    <strong>Dosha to Decrease:</strong> {item?.doshaDecrease}
                                                </span>
                                            }
                                            arrow
                                            placement="bottom"
                                        >
                                            <div
                                                className="food-item relative"
                                                onClick={() => handleSelectRecipe({ ...item, time: 'mid-day-snack' }, !isSelected)}
                                            >
                                                <div className="food-item-img-container mb-2">
                                                    <img
                                                        src={
                                                            item.imageLink?.includes('https://example.com/')
                                                                ? "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png"
                                                                : item.imageLink
                                                        }
                                                        onError={(e) => {
                                                            e.target.onerror = null; // prevent infinite loop
                                                            e.target.src = "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png";
                                                        }}
                                                        alt="Recipe"
                                                        className="food-image"
                                                    />

                                                    <input
                                                        type="checkbox"
                                                        className="overlay-checkbox"
                                                        checked={isSelected}
                                                        readOnly
                                                        style={{
                                                            width: "auto",
                                                            height: "auto",
                                                            top: "5px",
                                                            right: "8px",
                                                        }}
                                                    />
                                                </div>

                                                <p
                                                    className="mt-5 w-full"
                                                    style={{ wordWrap: "break-word", width: "10rem" }}
                                                >
                                                    {item?.recipe || item?.name}
                                                </p>
                                            </div>
                                        </Tooltip>
                                    );
                                })}
                            </div>

                        </div>

                        <div className="p-5 flex flex-col gap-5" >
                            <div className="flex flex-row justify-between items-center px-2" style={{
                                borderLeft: "5px solid #DA6E0B",
                                borderRadius: "8px"
                            }} >
                                <p style={{
                                    fontSize: "18px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                }}>Lunch</p>
                                <Button
                                    onClick={toggleDrawer(true, "lunch")}
                                    sx={{
                                        mt: 2,
                                        backgroundColor: '#fdfdfd',
                                        color: '#DA6E0B',
                                        borderRadius: '5px',
                                        padding: "5px 1rem",
                                        textTransform: 'none',
                                        border: "1px solid #DA6E0B",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,

                                    }}>
                                    <p style={{

                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                    }}>Add more</p>
                                </Button>
                            </div>

                            <div className="flex flex-wrap items-stretch">
                                {Array.from(
                                    new Map(
                                        [...recipeAIRecommendation, ...selectedRecipes]
                                            .filter((recipe) => recipe.time.includes('lunch'))
                                            .map((recipe) => [recipe.id, recipe])
                                    ).values()
                                )
                                    .map((item) => {
                                        const isSelected = selectedRecipes.some((i) => i.id === item.id);
                                        return (
                                            <Tooltip
                                                key={item.id}
                                                title={
                                                    <span>
                                                        <strong>Reason:</strong> {item?.reason}<br />
                                                        <strong>Dosha to Decrease:</strong> {item?.doshaDecrease}
                                                    </span>
                                                }

                                                arrow
                                                placement="bottom"
                                            >
                                                <div
                                                    className="food-item relative"
                                                    onClick={() => handleSelectRecipe({ ...item, time: 'lunch' }, !isSelected)}
                                                >
                                                    <div className="food-item-img-container mb-2">
                                                        <img
                                                            src={
                                                                item.imageLink?.includes('https://example.com/')
                                                                    ? "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png"
                                                                    : item.imageLink
                                                            }
                                                            onError={(e) => {
                                                                e.target.onerror = null; // prevent infinite loop
                                                                e.target.src = "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png";
                                                            }}
                                                            alt="Recipe"
                                                            className="food-image"
                                                        />

                                                        <input
                                                            type="checkbox"
                                                            className="overlay-checkbox"
                                                            checked={isSelected}
                                                            readOnly
                                                            style={{
                                                                width: "auto",
                                                                height: "auto",
                                                                top: "5px",
                                                                right: "8px",
                                                            }}
                                                        />
                                                    </div>

                                                    <p
                                                        className="mt-5 w-full"
                                                        style={{ wordWrap: "break-word", width: "10rem" }}
                                                    >
                                                        {item?.recipe || item?.name}
                                                    </p>
                                                </div>
                                            </Tooltip>
                                        );
                                    })}
                            </div>

                        </div>

                        <div className="p-5 flex flex-col gap-5" >

                            <div className="flex flex-row justify-between items-center px-2" style={{
                                borderLeft: "5px solid #DA6E0B",
                                borderRadius: "8px"
                            }} >
                                <p style={{
                                    fontSize: "18px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                }}>Snacks</p>
                                <Button
                                    onClick={toggleDrawer(true, "snack")}
                                    sx={{
                                        mt: 2,
                                        backgroundColor: '#fdfdfd',
                                        color: '#DA6E0B',
                                        borderRadius: '5px',
                                        padding: "5px 1rem",
                                        textTransform: 'none',
                                        border: "1px solid #DA6E0B",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,

                                    }}>
                                    <p style={{

                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                    }}>Add more</p>
                                </Button>
                            </div>

                            <div className="flex flex-wrap items-stretch">
                                {Array.from(
                                    new Map(
                                        [...recipeAIRecommendation, ...selectedRecipes]
                                            .filter((recipe) => recipe.time === ('snack'))
                                            .map((recipe) => [recipe.id, recipe])
                                    ).values()
                                ).map((item) => {
                                    const isSelected = selectedRecipes.some((i) => i.id === item.id && i.time === 'snack');
                                    return (
                                        <Tooltip
                                            key={item.id}
                                            title={
                                                <span>
                                                    <strong>Reason:</strong> {item?.reason}<br />
                                                    <strong>Dosha to Decrease:</strong> {item?.doshaDecrease}
                                                </span>
                                            }

                                            arrow
                                            placement="bottom"
                                        >
                                            <div
                                                className="food-item relative"
                                                onClick={() => handleSelectRecipe({ ...item, time: 'snack' }, !isSelected)}
                                            >
                                                <div className="food-item-img-container mb-2">
                                                    <img
                                                        src={
                                                            item.imageLink?.includes('https://example.com/')
                                                                ? "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png"
                                                                : item.imageLink
                                                        }
                                                        onError={(e) => {
                                                            e.target.onerror = null; // prevent infinite loop
                                                            e.target.src = "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png";
                                                        }}
                                                        alt="Recipe"
                                                        className="food-image"
                                                    />

                                                    <input
                                                        type="checkbox"
                                                        className="overlay-checkbox"
                                                        checked={isSelected}
                                                        readOnly
                                                        style={{
                                                            width: "auto",
                                                            height: "auto",
                                                            top: "5px",
                                                            right: "8px",
                                                        }}
                                                    />
                                                </div>

                                                <p
                                                    className="mt-5 w-full"
                                                    style={{ wordWrap: "break-word", width: "10rem" }}
                                                >
                                                    {item?.recipe || item?.name}
                                                </p>
                                            </div>
                                        </Tooltip>
                                    );
                                })}
                            </div>

                        </div>

                        <div className="p-5 flex flex-col gap-5" >

                            <div className="flex flex-row justify-between items-center px-2" style={{
                                borderLeft: "5px solid #DA6E0B",
                                borderRadius: "8px"
                            }} >
                                <p style={{
                                    fontSize: "18px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                }}>Dinner</p>
                                <Button
                                    onClick={toggleDrawer(true, "dinner")}
                                    sx={{
                                        mt: 2,
                                        backgroundColor: '#fdfdfd',
                                        color: '#DA6E0B',
                                        borderRadius: '5px',
                                        padding: "5px 1rem",
                                        textTransform: 'none',
                                        border: "1px solid #DA6E0B",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,

                                    }}>
                                    <p style={{

                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                    }}>Add more</p>
                                </Button>
                            </div>

                            <div className="flex flex-wrap items-stretch">
                                {Array.from(
                                    new Map(
                                        [...recipeAIRecommendation, ...selectedRecipes]
                                            .filter((recipe) => recipe.time.includes('dinner'))
                                            .map((recipe) => [recipe.id, recipe])
                                    ).values()
                                ).map((item) => {
                                    const isSelected = selectedRecipes.some((i) => i.id === item.id);
                                    return (
                                        <Tooltip
                                            key={item.id}
                                            title={
                                                <span>
                                                    <strong>Reason:</strong> {item?.reason}<br />
                                                    <strong>Dosha to Decrease:</strong> {item?.doshaDecrease}
                                                </span>
                                            }

                                            arrow
                                            placement="bottom"
                                        >
                                            <div
                                                className="food-item relative"
                                                onClick={() => handleSelectRecipe({ ...item, time: 'dinner' }, !isSelected)}
                                            >
                                                <div className="food-item-img-container mb-2">
                                                    <img
                                                        src={
                                                            item.imageLink?.includes('https://example.com/')
                                                                ? "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png"
                                                                : item.imageLink
                                                        }
                                                        onError={(e) => {
                                                            e.target.onerror = null; // prevent infinite loop
                                                            e.target.src = "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png";
                                                        }}
                                                        alt="Recipe"
                                                        className="food-image"
                                                    />

                                                    <input
                                                        type="checkbox"
                                                        className="overlay-checkbox"
                                                        checked={isSelected}
                                                        readOnly
                                                        style={{
                                                            width: "auto",
                                                            height: "auto",
                                                            top: "5px",
                                                            right: "8px",
                                                        }}
                                                    />
                                                </div>

                                                <p
                                                    className="mt-5 w-full"
                                                    style={{ wordWrap: "break-word", width: "10rem" }}
                                                >
                                                    {item?.recipe || item?.name}
                                                </p>
                                            </div>
                                        </Tooltip>
                                    );
                                })}
                            </div>

                        </div>
                    </div>
                }
            </div>

            {
                recipeAIRecommendation.length > 0 &&
                <div className='m-5' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{
                            textTransform: "none",
                            backgroundColor: "#DA6E0B",
                            color: "white",
                            border: "none",
                            boxSizing: "border-box",
                            borderRadius: "5px",
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: "10px",
                        }}
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        Save and Proceed
                    </Button>
                </div>
            }

        </div>

        <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
            <Box
                sx={{ width: 500, padding: "10px" }}
                role="presentation"
            >

                <div className='flex flex-col gap-4 p-4'>

                    {selectedTimning && <div className="flex flex-row justify-between items-center mb-3">
                        <p className="Prescription-sh-h">{selectedTimning?.charAt(0)?.toUpperCase() + selectedTimning?.slice(1)}</p>
                    </div>
                    }

                    <div>
                        <TextField
                            label="Search Recipes"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="flex flex-wrap justify-center items-stretch">
                        {AllRecipes
                            .filter((recipe) => {
                                const recipeName = recipe?.recipe?.toLowerCase() || "";
                                const search = searchTerm?.toLowerCase() || "";
                                return recipeName.includes(search);
                            })
                            .filter((e) => {
                                const category = e?.category?.toLowerCase() || "";
                                const timing = selectedTimning?.toLowerCase() === "mid-day-snack" ? "snack" : selectedTimning?.toLowerCase() || "snack";
                                return category.includes(timing) || category.includes("all");
                            })
                            .map((item) => {
                                const isSelected = selectedRecipes.some((i) => i.id === item.id);
                                return (
                                    <Tooltip
                                        key={item.id}
                                        title={
                                            <span>
                                                <strong>Reason:</strong> {item?.reason}<br />
                                                <strong>Dosha to Decrease:</strong> {item?.doshaDecrease}
                                            </span>
                                        }

                                        arrow
                                        placement="bottom"
                                    >
                                        <div
                                            className="food-item relative"
                                            onClick={() =>
                                                handleSelectRecipe(
                                                    { ...item, time: selectedTimning },
                                                    !isSelected
                                                )
                                            }

                                        >
                                            <div className="food-item-img-container mb-2">
                                                <img
                                                    src={
                                                        item.imageLink?.includes('https://example.com/')
                                                            ? "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png"
                                                            : item.imageLink
                                                    }
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png";
                                                    }}
                                                    alt="Recipe"
                                                    className="food-image"
                                                />

                                                <input
                                                    type="checkbox"
                                                    className="overlay-checkbox"
                                                    checked={isSelected}
                                                    readOnly
                                                    style={{
                                                        width: "auto",
                                                        height: "auto",
                                                        top: "5px",
                                                        right: "8px",
                                                    }}
                                                />
                                            </div>

                                            <p
                                                className="mt-5 w-full"
                                                style={{ wordWrap: "break-word", width: "10rem" }}
                                            >
                                                {item?.recipe || item?.name}
                                            </p>
                                        </div>
                                    </Tooltip>
                                );
                            })}
                    </div>

                </div>




            </Box>

        </Drawer>
    </div>

}

export default RecipeSuggestions